class Tokens {
  resetSessionStorageTokensForContactInfo() {
    sessionStorage["contact_info"] = "false";
    var token_obj = {};
    updateStorageToken(token_obj, "resetSessionStorageTokensForContactInfo_tokens_update");
  }

  documentInputElemOnfocus(user_input) {
    console.log("document input on focus document_input_elem_onfocus");
    if (sessionStorage["logon"] == "true") {
      var element_focussed = user_input.id.replace("left_filter_input_id_", "");
      window.element_focussed = element_focussed;
      console.log(element_focussed);
      // document.getElementById("input_enter_text_"+element_focussed).innerHTML = ""
      // These do an auto dropdown click and work automatically
      if (["grades", "genders", "function_root", "company_sizes", "industry", "company_type", "industry_category", "industry"].includes(element_focussed)) {
        // function doClick() {
        var focus_input_element = document.getElementById("left_filter_input_id_" + element_focussed);
        // triggerFocus(focus_input_element);
        // focus_input_element.value = ' '
        // console.log("Element focussed!!!")
        new Tokens().updateInputToken(focus_input_element);
        // focus_input_element.value = ""
        // do things
        // alert("Hello!");
        //   }
      }
    } else {
      showPaymentPopUpWhenLoggedOut();
    }

    mixpanel.track("Left Panel On Focus", {
      source: window.location.href.includes("org-chart") ? sessionStorage["current_focus"] : "home_page",
    });
    var lastClick = 0;
    var delay = 20;

    document.addEventListener("keydown", function (e) {
      if (e.repeat) {
        return;
      }
      if (e.keyCode == 13) {
        if (lastClick >= Date.now() - delay) return;
        lastClick = Date.now();
        try {
          console.log("Panda killing it document_input_elem_onfocus function");
          input_value = document.getElementById("left_filter_input_id_" + element_focussed).value;
          console.log(input_value);
          token_obj = {
            input_value: input_value,
            element_focussed: element_focussed,
          };
          updateStorageToken(token_obj, "raw_element_push");
          new Tokens().showTokensinUI();
          // document.getElementById("filters_autocomplete_dropdown_"+elem_focussed).value = ""
          // document.getElementById("left_filter_input_id_"+elem_focussed).value = ""
          // document.getElementById("input_enter_text_"+element_focussed).value = ""
          document.getElementById("left_filter_input_id_" + element_focussed).value = "";
          // document.getElementById("input_enter_text_"+element_focussed).innerHTML = "Enter "+element_focussed
        } catch (error) {
          console.log("Error:", error);
        }
      } else if (e.keyCode == 40) {
        if (e.repeat) {
          return;
        } else {
          if (["grades", "functions", "genders"].includes(element_focussed)) {
            // function doClick() {
            var focus_input_element = document.getElementById("left_filter_input_id_" + element_focussed);
            // triggerFocus(focus_input_element);
            // focus_input_element.value = ' '
            // console.log("Element focussed!!!")
            new Tokens().updateInputToken(focus_input_element);
            // focus_input_element.value = ""
            // do things
            // alert("Hello!");
            //   }
          }
        }
      }
    });
    return false;
  }

  documentRawTextInputElemOnblur(user_input) {
    console.log("Going to raw text input on blur");
    // console.log(user_input);
    // console.log("document input on blur::", user_input)
    var element_focussed = user_input.id.replace("left_filter_input_id_", "");
    var input_value = document.getElementById("left_filter_input_id_" + element_focussed).value;

    console.log("Element focussed:::%s", element_focussed);
    if ((element_focussed == "gpt3_company_search" || element_focussed == "reverse_job_title") & (input_value == "")) {
      new Selections().updateRawStringQueryInputText(user_input);

      var token_obj = {
        input_value: input_value,
        element_focussed: element_focussed,
      };
      updateStorageToken(token_obj, "raw_element_push");
    }
    new LeftPanelDropdownFilters().togglePlusIconMinusIcon(user_input);

    // document.getElementById("input_enter_text_"+element_focussed).innerHTML = "Enter "+ element_focussed
  }

  documentRawTextInputElemOnfocus(user_input) {
    // console.log(user_input);
    console.log("document input on focus documentRawTextInputElemOnfocus");
    var element_focussed = user_input.id.replace("left_filter_input_id_", "");
    return false;
  }

  onKeyPressUpdateRawTextQueryResults(user_input) {
    console.log("document input on focus onKeyPressUpdateRawTextQueryResults");
    console.log("User input element:::", user_input);

    console.log("Panda killing it");
    var element_focussed = user_input.id.replace("left_filter_input_id_", "");
    if (["gpt3_company_search", "reverse_job_title"].includes(element_focussed)) {
      new Selections().updateRawStringQueryInputText(user_input);
    } else {
      // Do nothing
    }
    var input_value = document.getElementById("left_filter_input_id_" + element_focussed).value;
    console.log(input_value);

    var token_obj = {
      input_value: input_value,
      element_focussed: element_focussed,
    };
    updateStorageToken(token_obj, "raw_element_push");
    new Tokens().showTokensinUI();
    // document.getElementById("filters_autocomplete_dropdown_"+elem_focussed).value = ""
    // document.getElementById("left_filter_input_id_"+elem_focussed).value = ""
    // document.getElementById("input_enter_text_"+element_focussed).value = ""
    document.getElementById("left_filter_input_id_" + element_focussed).value = "";
    // document.getElementById("input_enter_text_"+element_focussed).innerHTML = "Enter "+element_focussed
    new Query().fetchQueryShowResults("load_data_without_loading_tokens");
    new Tokens().documentRawTextInputElemOnblur(user_input);
  }

  clearFilterElementButton(user_input) {
    console.log("this got clicked", user_input);
  }

  resetFunctionsGradesDropdown() {
    console.log("Resetting all functions and grades in the dropdown!!!!");
    var token_obj = {};
    updateStorageToken(token_obj, "resetFunctionsGradesDropdown");
  }

  clearAllTokens() {
    new ProcessNodesStates().resetSessionStorageforDropdowns();
    new Tokens().updateDataBasedonChangedTokens();
    // showTokensLoadResults('clearAllTokens')
    // showTokensinUI()
  }

  updateInputToken(user_input) {
    // console.log("Updating input token!--", user_input)

    var dropdown_id = user_input.id;
    var dropdown_field_id = dropdown_id.replace("left_filter_input_id_", "");
    var input_text = user_input.value;
    sessionStorage["new_input_text_token"] = input_text;
    var input_field_focussed_id = user_input["id"];
    var input_field_obj = JSON.stringify({
      input_field_focussed_id: input_field_focussed_id,
      user_input: input_text,
    });
    console.log("Sending input field object::", input_field_obj);
    // document.getElementById("company_info").innerHTML = '<div style="width:100%;text-align:center"><img style="width:30px" src="/static/img/new_loading2.gif"/></div>'
    setTimeout("new SearchBarLoadersDropdowns().getDataLoadAutocompleteDropdown('" + input_field_obj + "');", 500);
    // setime to sleep and then call an ajax function that gets data and opens up the damn dropdown
  }

  updateRawTextInputToken(user_input) {
    new UtilityFunctions().auto_grow(user_input);
    console.log("This is the update raw text input token function being used");
    var input_text = user_input.value;
    var dropdown_id = user_input.id;
    sessionStorage["new_input_text_token"] = input_text;
    var input_field_focussed_id = user_input["id"];
    var input_field_obj = {
      input_field_focussed_id: input_field_focussed_id,
      user_input: input_text,
    };
    console.log("Bulldog killing it in new Tokens().updateRawTextInputToken");
    var element_focussed = user_input.id.replace("left_filter_input_id_", "");
    var input_value = document.getElementById("left_filter_input_id_" + element_focussed).value;
    console.log(input_value);
    var token_obj = {
      input_value: input_value,
      element_focussed: element_focussed,
    };
    updateStorageToken(token_obj, "raw_element_push");
    // showTokensinUI()

    console.log(input_field_obj);
    // new Query().fetchQueryShowResults('load_data_without_loading_tokens')
  }

  getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    // if (screen.width < 800){
    //     console.log("Choosing smaller font");
    //     // font = font * .3
    //     context.font = '4pt BlinkMacSystemFont';
    // }
    // else{
    //     context.font = '4pt BlinkMacSystemFont';
    // }
    // context.font = '6pt BlinkMacSystemFont';
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  }

  showTokensinUI() {
    console.log("Got here to show tokens in the UI showTokensinUI");
    // console.log(dropdown_class_name)
    var query_obj = JSON.parse(sessionStorage["query"]);
    console.log(query_obj);
    for (var j = 0; j < Object.keys(query_obj).length; j++) {
      // console.log(Object.keys(query_obj)[i])
      if ((Object.keys(query_obj)[j] != "company_id") | (Object.keys(query_obj)[j] != "raw_text")) {
        var token_rows = "";
        var dropdown_class_name = Object.keys(query_obj)[j];
        if (dropdown_class_name == "functions") {
          if (typeof query_obj["std_function"] == "object") {
            if (query_obj["std_grade"].length > 0) {
              // remove_duplicates_company_ids = getUniqueListBy([].concat(existing_tokens['company_id'], turnArraytoArrayofObjects(token_obj['companies_ids_list'])), 'name');
              query_obj[dropdown_class_name] = new UtilityFunctions().getUniqueListBy([].concat(query_obj[dropdown_class_name].concat(query_obj["std_function"])));
            }
          }
        }
        if (dropdown_class_name == "grades") {
          if (typeof query_obj["std_grade"] == "object") {
            if (query_obj["std_grade"].length > 0) {
              query_obj[dropdown_class_name] = new UtilityFunctions().getUniqueListBy([].concat(query_obj[dropdown_class_name].concat(query_obj["std_grade"])));
              // query_obj[dropdown_class_name] = query_obj[dropdown_class_name].concat(query_obj['std_grade'])
            }
          }
        }
        var minus_clicked_tokens = [];
        for (var i = 0; i < query_obj[dropdown_class_name].length; i++) {
          // console.log(dropdown_class_name)
          // console.log(query_obj[dropdown_class_name][i])
          // togglePlusIconMinusIcon(user_input)
          // Because when logged out, there is no left panel, so no problems of showing the signs
          if (sessionStorage["logon"] == "true") {
            if (sessionStorage["isOpenPlusMinusFilter_" + dropdown_class_name] == "no") {
              new LeftPanelDropdownFilters().makeVisibleLeftPanelFilterDropDownElement(dropdown_class_name);
            }
          }
          var text_token = document.getElementById("text_token").innerHTML;
          token_rows =
            token_rows +
            text_token
              .replaceAll("{token_name}", query_obj[dropdown_class_name][i]["name"])
              // .replaceAll("{token_width}", query_obj[dropdown_class_name][i].length*13)
              .replaceAll("{token_width}", new Tokens().getTextWidth(query_obj[dropdown_class_name][i], "12pt Roboto") + 35)
              .replaceAll("{dropdown_class_name_}", "dropdown_class_name_" + dropdown_class_name);
          if (query_obj[dropdown_class_name][i]["exclude"] == true) {
            minus_clicked_tokens.push(query_obj[dropdown_class_name][i]["name"]);
          }
        }
        // console.log(dropdown_class_name);
        try {
          // some of the elements are not in each org chart/ people/ companies
          document.getElementById("search_selection_tokens_id_" + dropdown_class_name).innerHTML = token_rows;
        } catch (error) {}
        // console.log(minus_clicked_tokens)
        // Guessing the name of the variable dropdown_class_name is changing as we go into the click loop
        var dropdown_class_name_token_update = dropdown_class_name;
        // console.log(dropdown_class_name_token_update)
        for (var i = 0; i < minus_clicked_tokens.length; i++) {
          document.getElementById("plus_minus_sign_" + minus_clicked_tokens[i] + "-class-name-dropdown_class_name_" + dropdown_class_name_token_update).click();
        }
      }
      try {
        // console.log("Going to try to remove the elements that are not going to clear the filter id")
        var filter_name = Object.keys(query_obj)[j];
        if (query_obj[filter_name].length > 0) {
          document.getElementById("clear_filter_input_filter_id_" + filter_name).innerHTML =
            "<label onclick=ClearFiltersPanel(this) id=clear_filters_" + filter_name + ' class=" prospecting-style-tag-filters-97ijzq-placeholder" for="clear_filter_item">Clear</label>';
        } else {
          document.getElementById("clear_filter_input_filter_id_" + filter_name).innerHTML = "";
        }
      } catch (error) {}

      try {
        if (query_obj["checkbox_has_email"] == true) {
          document.getElementById("checkbox_email_address_left_panel").checked = true;
        }
        if (query_obj["checkbox_has_phone"] == true) {
          document.getElementById("checkbox_phone_number_left_panel").checked = true;
        }
      } catch (error) {}
    }
  }

  close_token(user_input) {
    console.log("user input for close token");
    console.log(user_input);
    // token_id_clicked = user_input.id.replace("token-close-","");
    // for (var i=0; i < user_input.classList.length; i++){
    //     if (user_input.classList[i].includes('dropdown_class_name_')){
    //         dropdown_class = user_input.classList[i]
    //     }
    // }
    var dropdown_class = user_input.getAttribute("dropdown_class_name");
    var token_id_clicked = user_input.getAttribute("token_name");
    // console.log(dropdown_class)
    var dropdown_class_name = dropdown_class.replace("dropdown_class_name_", "");
    console.log(dropdown_class_name);
    document.getElementById("token-" + token_id_clicked + "-class-name-" + dropdown_class).remove();
    var token_obj = {};
    token_obj["dropdown_class_name"] = dropdown_class_name;
    token_obj["token_id_clicked"] = token_id_clicked;
    updateStorageToken(token_obj, "close_token_object");
    new Tokens().updateDataBasedonChangedTokens();
    console.log("Token changes made");
  }
  async closeTokenEditJd(user_input) {
    console.log("hit close token edit jd", user_input);
    // var dropdown_class = user_input.getAttribute("dropdown_class_name");
    // var token_id_clicked = user_input.getAttribute("token_name");
    var token_name = user_input.getAttribute("token_name");
    var token_for = user_input.getAttribute("token_for");
    console.log("Token for::", token_for);
    // var dropdown_class_name = dropdown_class.replace("dropdown_class_name_","");
    // console.log(dropdown_class_name);
    // document.getElementById("token-" + token_id_clicked + "-class-name-" + dropdown_class).remove();
    // var token_obj = {};
    // token_obj["token_id_clicked"] = token_id_clicked;
    // updateStorageToken(token_obj, token_for);
    let client_query_obj = new EditJDComponents().getCurrentJobClientQueryObject();
    if (token_for == "edit_jd_company_tokens") {
      let regex = token_name;
      try {
        regex = regex.split(" ");
        regex = regex[0];
      } catch (error) {
        console.log("company id can't find and remove for::", token_name);
        regex = token_name;
      }
      regex = new RegExp(regex);
      let companyNameData = client_query_obj?.company_name?.length > 0 ? client_query_obj.company_name : [];
      let companyIdData = client_query_obj?.company_id?.length > 0 ? client_query_obj.company_id : [];
      companyNameData = companyNameData.filter((item) => item.name !== token_name);
      companyIdData = companyIdData.filter((item) => !item.name.match(regex));
      client_query_obj.company_name = companyNameData;
      client_query_obj.company_id = companyIdData;
    } else if (token_for == "edit_jd_location_tokens") {
      let locationsData = client_query_obj?.locations?.length > 0 ? client_query_obj.locations : [];
      locationsData = locationsData.filter((item) => item.name !== token_name);
      client_query_obj.locations = locationsData;
    } else if ((token_for = "selected_option_chips")) {
      console.log("Token for ius selected_option_chips", token_for);
      console.log("This is this", user_input);
      console.log("This is this.token_name", user_input.getAttribute("token_name"));
      new Components().removeChipInUIbyId("selected_option_chips", user_input.getAttribute("token_name"));
      new UtilityFunctions().get_gpt_cost_by_token();
      return;
    }
    await new EditJDComponents().setClientQueryObjectToCurrentJob(client_query_obj);
    console.log("Set client query object to current clietn query object");
    await new Components().addChipInUIbySessionStorage(token_for, token_for);
  }

  updateDataBasedonChangedTokens() {
    if (sessionStorage["current_focus"] == "people") {
      new Toggle().togglePeople();
    } else if (sessionStorage["current_focus"] == "companies") {
      new Toggle().toggleCompanies();
    } else if (sessionStorage["current_focus"] == "orgcharts") {
      new Toggle().toggleOrgCharts();
    }
  }

  clearFiltersPanelElement(user_input) {
    console.log("clicked on this::", user_input);
    var filter_to_clear = user_input.getAttribute("filter_id");
    var token_obj = { filter_to_clear: filter_to_clear };
    updateStorageToken(token_obj, "filter_to_clear");
    new Tokens().showTokensinUI();
  }

  showTokensLoadResults(token_source) {
    console.log("Got here to show tokens, get results in showTokensLoadResults");
    var blank_session_storage_obj = sessionStorage["blank_session_storage_obj"];
    if (token_source == "searchAutoCompleteDropDownClick") {
      new Query().fetchQueryShowResults();
    }
    new Tokens().showTokensinUI();
  }

  plusMinusSignTokenClicked(user_input) {
    console.log("plusMinusSignTokenClicked:::::");
    var token_name = user_input.getAttribute("token_name");
    var dropdown_class_name = user_input.getAttribute("dropdown_class_name");
    console.log("Clicked on token_name::", token_name);
    console.log("Clicked on dropdown_class_name::", dropdown_class_name);
    var plus_minus_sign_obj = document.getElementById("plus_minus_sign_" + token_name + "-class-name-" + dropdown_class_name);
    var token_text_obj = document.getElementById("token_text_" + token_name + "-class-name-" + dropdown_class_name);
    var token_close_obj = document.getElementById("token-close-" + token_name + "-class-name-" + dropdown_class_name);
    var current_status_plus_minus = plus_minus_sign_obj.getAttribute("class");
    console.log("This is current_status_plus_minus ::", current_status_plus_minus);
    // Toggle between select and unselect the browser token
    if (current_status_plus_minus == "token_filter_background_plus") {
      plus_minus_sign_obj.setAttribute("class", "token_filter_background_minus");
      token_text_obj.setAttribute("class", "token_filter_background_minus");
      token_close_obj.setAttribute("class", "token_filter_background_minus");
      // document.getElementById("plus_minus_sign_"+token_name+'-class-name-'+dropdown_class_name).innerHTML = '<img id="plus_sign_with_outline" width="10" height="10"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAAqUlEQVQokZXRMW4CMRAF0LeQhjI1LTSRIg6QI0QpoCQVl4CUW3ISaBANN8lKVJQ5QRqoAsXOspIVr8SXrPGf7+/xeHgQRcQe5hhmzv1gg2s/Ep9YhjD4Zy3wi+opDCPsUQaf4A9V8AvG0BhSTCNWqZAaXvCBt+ArHLoM8BzvbvadFY740vZSJnq2h10mfzec1N96TvT3iDOsaQdXqAf3mrn4G1tcc5WzuAFUxxgsn0xYwwAAAABJRU5ErkJggg==">'
      document.getElementById("plus_minus_sign_" + token_name + "-class-name-" + dropdown_class_name).innerHTML =
        '<img   id="plus_sign_with_outline" width="12" height="12" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAU0lEQVR4nO3TwQmAUAwFwfTfdLx7VtwvM5ACHktmAIDX7e2OtYbEKFKjSI0iNYrUKFKTK7If32MMGUUm/VvHWkNiFKlRpEaRGkVqFKn5TREAmBNcXKbvEbAKdz4AAAAASUVORK5CYII=">';
      var token_obj = {
        token_name: token_name,
        dropdown_class_name: dropdown_class_name.replace("dropdown_class_name_", ""),
      };
      updateStorageToken(token_obj, "token_filter_background_plus");
    } else {
      plus_minus_sign_obj.setAttribute("class", "token_filter_background_plus");
      token_text_obj.setAttribute("class", "token_filter_background_plus");
      token_close_obj.setAttribute("class", "token_filter_background_plus");
      // document.getElementById("plus_minus_sign_"+token_name+'-class-name-'+dropdown_class_name).innerHTML = '<img id="minus_sign_with_outline"  width="10" height="10"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAAiUlEQVQokZ3RKw7CUBAF0FOoQaKxYJqwFAySKjZBkEhWQl1NdwIJCskKMOCK6CMkDa/J4yaTyXxu7nxIRBb8CBvMIn13nNCOQ6LELhQmP2yLBy55IMxR4xBReGHxGSUJeS8usOrlmiECTFMUrtgPEf7e4aY76zPSt8aR7+My3eOWEcIZFdrUibwBF/MSQT5fNw8AAAAASUVORK5CYII=">'
      document.getElementById("plus_minus_sign_" + token_name + "-class-name-" + dropdown_class_name).innerHTML =
        '<img id="minus_sign_with_outline" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGUlEQVR4nGNgGOEgnYGBoRoHTqeKBoaRAgBv9AdhQ50AhwAAAABJRU5ErkJggg==">';
      token_obj = {
        token_name: token_name,
        dropdown_class_name: dropdown_class_name.replace("dropdown_class_name_", ""),
      };
      updateStorageToken(token_obj, "token_filter_background_minus");
    }
    // fetchQueryShowResults()
    new Query().fetchQueryShowResults("load_data_without_loading_tokens");
    // updateDataBasedonChangedTokens()
  }
}

class Toggle {
  switchViewToCompanies() {
    console.log("switchViewToCompanies function Called");
    window.history.pushState(null, null, "/companies/");
    // console.log()
    try {
      document.getElementById("right_panel_org_chart_people_companies").innerHTML = "";
    } catch (error) {
      console.log("Error:", error);
    }
    // document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("right_search_results_companies_element").innerHTML
    document.getElementById("header_element").innerHTML = document.getElementById("companies_header_element").innerHTML;
    document.getElementById("header_element_mobi").innerHTML = document.getElementById("companies_header_element").innerHTML;

    sessionStorage["current_focus"] = "companies";
    // document.getElementById("show_tab_indicator").innerHTML = '<div style="height:4px;bottom:-3px;left:15px;background-color:rgb(36,116,204);width:65px;transition:all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0s;transform:translateX(63px);"></div>'
    // document.getElementById("show_tab_indicator").innerHTML = ''
    new Toggle().setHeadlineLeftPanelUnderLineTabs("companies");
    var filter_type = "companies";
    // showCompaniesResults(data)
    new LeftPanelDropdownFilters().loadFiltersPanel(filter_type);
    new Tokens().showTokensLoadResults();
  }

  switchViewToOrgCharts() {
    console.log("switchViewToOrgCharts function called");
    window.history.pushState(null, null, "/org-chart/");
    // Here you are changing the load type to query!!! WE have changed this in
    // sessionStorage['load_type'] = 'query'
    console.log("Got here to toggle Org Charts");

    sessionStorage["current_focus"] = "orgcharts";
    var filter_type = "orgcharts";
    updateStorageToken({}, "toggleOrgCharts");
    // showOrgChartResults()
    new LeftPanelDropdownFilters().loadFiltersPanel(filter_type);
    // height = ($(window).height() -184).toString() // -188
    var width = $(window).width();
    // if (width > 600){
    //     padding_left_func_drop = '90';
    //     padding_left_geo_drop = '95';
    // }
    // else if (width < 600 ) {
    //     padding_left_func_drop = '10';
    //     padding_left_geo_drop = '0';
    // }
    // have to eliminate padding_left_func_drop and padding_left_geo_drop/ not being used
    console.log("Called toggle Org Charts!");
    document.getElementById("search_bar_search_center").style.display = "block";

    // document.getElementById("right_panel_org_chart_people_companies").innerHTML = ""
    try {
      document.getElementById("right_panel_org_chart_people_companies").innerHTML = "";
    } catch (error) {
      console.log("Error:", error);
    }
    document.getElementById("header_element").innerHTML = document.getElementById("org_chart_header_element").innerHTML;
    // .replaceAll('{padding_left_func_drop}', padding_left_func_drop )
    // .replaceAll('{padding_left_geo_drop}', padding_left_geo_drop )
    document.getElementById("header_element_mobi").innerHTML = document.getElementById("org_chart_header_element").innerHTML;
    // .replaceAll('{padding_left_func_drop}', padding_left_func_drop )
    // .replaceAll('{padding_left_geo_drop}', padding_left_geo_drop )
    // document.getElementById("show_tab_indicator").innerHTML = ''

    try {
      // document.getElementById("show_tab_indicator").innerHTML = '<div style="height:4px;bottom:-3px;left:15px;background-color:rgb(36,116,204);width:65px;transition:all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0s;transform:translateX(155px);"></div>'
      new Toggle().setHeadlineLeftPanelUnderLineTabs("orgcharts");
    } catch (error) {
      console.log("Error:", error);
    }
    // document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("start_search_element").innerHTML
    new DrawOrgCharts().clearOrgChartFunctionGradeTokens();
    new Tokens().showTokensLoadResults();
  }

  switchViewToLists() {
    window.history.pushState(null, null, "/lists/");
    new Toggle().setHeadlineLeftPanelUnderLineTabs("lists");
    new PageContents().changePage("/lists");
  }

  switchViewToPeople() {
    console.log("switchViewToPeople function called");
    window.history.pushState(null, null, "/people/");
    console.log("Got heret to toggle people");
    sessionStorage["current_focus"] = "people";
    document.getElementById("header_element").innerHTML = document.getElementById("people_header_element").innerHTML;
    document.getElementById("header_element_mobi").innerHTML = document.getElementById("people_header_element").innerHTML;
    // document.getElementById("show_tab_indicator").innerHTML = ''
    // document.getElementById("show_tab_indicator").innerHTML = '<div style="height:4px;bottom:-3px;left:15px;background-color:rgb(36,116,204);width:40px;transition:all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0s;transform:translateX(0px);"></div>'
    new Toggle().setHeadlineLeftPanelUnderLineTabs("people");
    try {
      document.getElementById("right_panel_org_chart_people_companies").innerHTML = "";
    } catch (error) {
      console.log("Error:", error);
    }
    var filter_type = "people";
    new LeftPanelDropdownFilters().loadFiltersPanel(filter_type);
    new Tokens().showTokensLoadResults();
  }

  setHeadlineLeftPanelUnderLineTabs(headline_type) {
    if (headline_type == "lists") {
      document.getElementById("left_panel_toggle_navigation_companies").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_people").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.fontWeight = "900";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecoration = "underline";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecorationThickness = "3px";
    } else if (headline_type == "companies") {
      document.getElementById("left_panel_toggle_navigation_companies").style.fontWeight = "900";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecoration = "underline";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecorationThickness = "3px";
      document.getElementById("left_panel_toggle_navigation_people").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecorationThickness = "";
    } else if (headline_type == "people") {
      document.getElementById("left_panel_toggle_navigation_companies").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_people").style.fontWeight = "900";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecoration = "underline";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecorationThickness = "3px";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecorationThickness = "";
    } else if (headline_type == "orgcharts") {
      document.getElementById("left_panel_toggle_navigation_companies").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_companies").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_people").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_people").style.textDecorationThickness = "";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.fontWeight = "900";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecoration = "underline";
      document.getElementById("left_panel_toggle_navigation_orgcharts").style.textDecorationThickness = "3px";
      document.getElementById("left_panel_toggle_navigation_lists").style.fontWeight = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecoration = "";
      document.getElementById("left_panel_toggle_navigation_lists").style.textDecorationThickness = "";
    } else {
    }
  }

  togglePeoplewithData(data) {
    console.log("togglePeoplewithData function called");
    this.switchViewToPeople();
    console.log("Got here to show tokens, get results in togglePeoplewithData");
    var blank_session_storage_obj = sessionStorage["blank_session_storage_obj"];
    var loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br><span style="font-size:10pt">Searching your data...</span></div>';
    document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = loader;
    document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = loader;
    var response = {};
    response["results"] = {};
    response["results"]["data"] = {};
    response["results"]["data"]["modified_query_results"] = data;
    response["number_results"] = data.length;
    response["count_db_results"] = data.length;
    new LoadDataPeopleCompaniesOrgCharts().loadResults(response);
    new Tokens().showTokensinUI();
    new Tokens().resetSessionStorageTokensForContactInfo();
  }

  toggleCompanies() {
    console.log("toggleCompanies function called");
    this.switchViewToCompanies();
    new Query().fetchQueryShowResults();
    new Tokens().resetSessionStorageTokensForContactInfo();
  }

  hideTooltip() {
    try {
      jQuery(document.getElementById("left_panel_toggle_navigation_lists")).attr("data-original-title", {}).tooltip("hide");
    } catch {}
  }

  toggleLists() {
    this.hideTooltip();
    // jQuery(document.getElementById('left_panel_toggle_navigation_lists')).attr('data-original-title', {}).tooltip('hide');
    this.switchViewToLists();
    // this.hideTooltip()
  }

  togglePeople() {
    console.log("togglePeople function called");
    // this.hideTooltip()

    this.switchViewToPeople();
    new Query().fetchQueryShowResults();
    new Tokens().resetSessionStorageTokensForContactInfo();
  }

  toggleOrgCharts() {
    // jQuery(document.getElementById('left_panel_toggle_navigation_orgcharts')).attr('data-original-title', {}).tooltip('hide');
    // this.hideTooltip()

    console.log("toggleOrgCharts function called");
    this.switchViewToOrgCharts();
    new Query().fetchQueryShowResults();
    new Tokens().resetSessionStorageTokensForContactInfo();

    new LeftPanelDropdownFilters().removeLeftPanelforOrgChartwhenLoggedOut();

    // if (sessionStorage['use_case'] != 'agency'){
    //     console.log("Removing left panel because use case is not agency")
    //     console.log("This is current session use case::",sessionStorage['use_case'])
    //     removeLeftPandelforOrgChartwhenLoggedIn()
    // }
  }
}


export { Tokens, Toggle };
if (typeof window !== 'undefined') {
  window.Tokens = Tokens;
  window.Toggle = Toggle;
}
